import React from 'react';
import {Button, Space, Tooltip} from "antd";
import {EditOutlined, KeyOutlined, TranslationOutlined, HistoryOutlined} from "@ant-design/icons";
import {DeleteAction} from "../../../../components/table/action/delete.action";
import {BaseModule} from "../../../../types/modules";
import {useNavigate} from "react-router-dom";
import {ActionEnum} from "../../../../types/enums";
import {HelperService} from "../../../../service/helper.service";
import {Translate} from "../../../../components/util/translation.util";
import {EyeOutlined} from "@ant-design/icons/lib/icons";

type ActionElement = {
    icon?: any,
    component?: any,
}

const Action: { [name: string]: ActionElement } = {
    [ActionEnum.VIEW]: { icon: EyeOutlined },
    [ActionEnum.EDIT]: { icon: EditOutlined },
    [ActionEnum.ACCESSES]: { icon: KeyOutlined },
    [ActionEnum.TRANSLATE]: { icon: TranslationOutlined },
    [ActionEnum.DELETE]: { component: DeleteAction },
    [ActionEnum.VIEW_HISTORY]: { icon: HistoryOutlined },
} as const;

type ActionKeys = keyof typeof Action;

export const TableRowActions: React.FC<{
    module: string,
    record: BaseModule,
    actions: string[],
}> = ({ module, record, actions }) => {
    const navigate = useNavigate();

    return (
        <Space size="small">
            { actions && actions.map((action, key) => {
                const access = record.accessChecks?.find((x: any) => x.routeName === HelperService.generateURL(module, action));

                if (access && (access?.allowed && access.allowed)) {
                    if (Action[action as ActionKeys].component) {
                        let Component = Action[action as ActionKeys].component;
                        return <Component key={ key } />
                    }

                    if (Action[action as ActionKeys].icon) {
                        let Icon = Action[action as ActionKeys].icon;

                        return (
                            <Tooltip key={ key } title={<Translate message={`global.action.${action}`} />}>
                                <Button type="dashed" shape="circle" icon={ <Icon /> } onClick={() => { navigate(`/${module}/${record.id}/${action}`) }} />
                            </Tooltip>
                        )
                    }}
                    return null;
                }
            )}
        </Space>
    )
}